import { Component, Host, h, Element, State, Listen, Prop, Event, EventEmitter } from '@stencil/core';
import { AppService, DomService, RCM_NO_USER_TYPE_COUNTRIES } from '../../services';
import { ButtonAppearance, ButtonFontSize, ButtonType } from '../rcm-button/rcm-button.types';
import { UserType } from '../../../types/user-type';

@Component({
  tag: 'rcm-user-switcher',
  styleUrl: 'rcm-user-switcher.scss',
  shadow: true,
})
export class RcmUserSwitcher {
  @Prop() userTypeOptions: UserType[];

  @State() currentUserType: UserType;

  @Element() el: HTMLElement;

  @Event() userSwitchActiveEvent: EventEmitter;

  currentCountry = DomService.getGlobalConfig().country;

  private triggerUserSwitchModal() {
    this.userSwitchActiveEvent.emit({ userSwitcherOpen: true });
    window.dispatchEvent(new CustomEvent('rcmUserSwitchOpen'));
  }

  componentWillLoad() {
    this.currentUserType = AppService.getUserType();
    if (!this.currentUserType || !AppService.isCurrentUserCountryConsentStored(this.currentUserType, this.currentCountry)) {
      this.triggerUserSwitchModal();
    }
  }

  @Listen('rcmUserSwitchClose', {
    target: 'window',
  })
  rcmUserSwitchOpenHandler() {
    this.currentUserType = AppService.getUserType();
  }

  render() {
    return (
      <Host>
        <rcm-button
          class={{ 'user-type-switcher--hide': !this.userTypeOptions || this.userTypeOptions.length <= 1 }}
          onRcmButtonClick={() => this.triggerUserSwitchModal()}
          text={DomService.getGlobalContent().navigation?.userTypeSwitch[this.currentUserType]}
          type={ButtonType.BUTTON}
          appearance={ButtonAppearance.TERTIARY}
          fontSize={ButtonFontSize.SMALL}
        ></rcm-button>
      </Host>
    );
  }
}
